import React from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';

export default function ImpersonationBanner() {
  const { impersonating, user, stopImpersonating } = useAuth();
  const navigate = useNavigate();

  if (!impersonating) return null;

  function handleStop() {
    stopImpersonating();
    navigate('/admin', { replace: true });
  }

  return (
    <div className="impersonation-banner">
      <span>Ahora mismo eres: <b>{user?.username || 'Usuario'}</b></span>
      <button type="button" className="impersonation-banner-btn" onClick={handleStop}>
        Volver a admin
      </button>
    </div>
  );
}
